import useSearchState from '../hooks/useSearch';
import { Box, Spinner } from '@chakra-ui/react';
import React from 'react';

export function SearchResultsSection({ children }) {
  const { searchState } = useSearchState();
  const validatedAddress = searchState.validatedAddress;
  const isLoadingSearchAddress = searchState.isLoading;
  return validatedAddress ? (
    children
  ) : isLoadingSearchAddress ? (
    // Loading state when no validated address is set
    <Box py={10} textAlign='center'>
      <Spinner size='xl' color='blue.500' />
    </Box>
  ) : null;
}
